export default {"src":"/_next/static/image/public/images/flags/flag_358.8684d8e94b47bfb1da73a95322d920f8.svg","height":16,"width":24};